import React from 'react';
import { Phone, FileText, Headphones } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = ({ onGetItNowClick, onSelectTab }) => {
  return (
    <>
      {/* Top Bar - Simplified */}
      <div className="bg-[#FF6600] text-white py-3 px-4">
        <div className="container mx-auto flex justify-center items-center text-sm">
          <span className="font-bold">TURBO AHEAD, MALAYSIA | HIGH-SPEED INTERNET FOR EVERYONE</span>
        </div>
      </div>

      {/* Main Navbar */}
      <nav className="bg-white shadow-sm py-4 px-4 sticky top-0 z-50">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center gap-6">
            {/* Logo on left */}
            <img 
              src="https://customer-assets.emergentagent.com/job_unifi-platform/artifacts/c6fju4ts_penjual%20sah%20logo.avif" 
              alt="TM Penjual Sah Authorised Reseller" 
              className="h-10"
            />
            
            {/* Navigation links on right */}
            <div className="flex items-center gap-6">
            <a 
              href="/" 
              onClick={(e) => {
                e.preventDefault();
                onSelectTab && onSelectTab('home');
              }}
              data-testid="nav-unifi-home"
              className="text-gray-700 hover:text-[#FF6600] transition-colors font-medium"
            >
              unifi Home
            </a>
            <a 
              href="/?type=business" 
              onClick={(e) => {
                e.preventDefault();
                onSelectTab && onSelectTab('business');
              }}
              data-testid="nav-unifi-business"
              className="text-gray-700 hover:text-[#FF6600] transition-colors font-medium"
            >
              unifi Business
            </a>
            <Button 
              onClick={onGetItNowClick}
              className="bg-[#FF6600] hover:bg-[#E55A00] text-white px-6 py-2 rounded transition-all"
            >
              GET IT NOW
            </Button>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
